import PropTypes from "prop-types";
import { useContext, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import useEsriMap from "../../hooks/useEsriMap";
import { handleMapViewClick } from "../../utils/API";
import { ConfigContext } from "../../utils/ConfigContext";
import { StyledLoader } from "../App/App-styled";
import ContextMenu from "../ContextMenu";
import PrintMask from "../PrintMask/PrintMask";
import {
  StyledMapContainer,
  StyledMapLoaderContainer,
} from "./MapContainer-styled";

const MapContainer = ({
  setSideBarIFrame,
  sideBarIFrame,
  activeModule,
  activeLanguage,
  setActiveLanguage,
  setFeatureTableActive,
  setSideBarMobile,
  style,
}) => {
  const elementRef = useRef();
  const { config } = useContext(ConfigContext);
  const printWidget = useSelector((state) => state.printWidget);
  const dashboard = useSelector((state) => state.dashboard);
  const view = useSelector((store) => store.mapViewReducer.view);

  const { errors } = useEsriMap({
    elementRef,
    activeModule,
    activeLanguage,
    setActiveLanguage,
    setFeatureTableActive,
  });

  /*
	useEffect(() => {
		if (!view)
			return;

		view.on("click", () => {
			view.ui._components.forEach((comp) => {
				if (comp.widget && typeof comp.widget.collapse === 'function')
					comp.widget.collapse()
			})

		})
	});
	*/

  useEffect(() => {
    if (!view) return;

    if (sideBarIFrame === "pleaseselect") {
      let handler = view.on("click", (event) => {
        handleMapViewClick({
          event,
        });
        handler.remove();
      });
    }
  }, [sideBarIFrame, config, setSideBarIFrame]);

  return (
    <>
      <ContextMenu />
      <StyledMapContainer
        style={style}
        id="viewDiv"
        className="onboarding-map"
        ref={elementRef}
        data-testid="map-container-viewDiv"
        hideCanvas={dashboard.editorDrawActive}
      >
        {printWidget.open && elementRef.current && (
          <PrintMask parent={elementRef.current} config={config} />
        )}
      </StyledMapContainer>
      {!view && (
        <StyledMapLoaderContainer>
          <StyledLoader style={{ margin: 0, padding: 0 }}>
            <calcite-loader></calcite-loader>
          </StyledLoader>
        </StyledMapLoaderContainer>
      )}
    </>
  );
};

MapContainer.propTypes = {
  config: PropTypes.object,
  AppErrors: PropTypes.array,
  opLayersVisible: PropTypes.bool,
};

export default MapContainer;
